import { loader } from 'graphql.macro'

export default function resourcesCharts ({ dataLoaders, queryKey }) {
  const [, variables] = queryKey
  const schema = loader('./resourcesCharts.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(schema, { haulerId: variables.haulerId })
}
